import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "name", "latitude", "longitude", "placeId", "street", "city", "state", "postalCode", "country"]

  connect() {
    this.waitForGoogleMaps()
  }

  waitForGoogleMaps() {
    if (typeof google !== "undefined" && google.maps) {
      this.initializeAutocomplete()
    } else {
      setTimeout(() => this.waitForGoogleMaps(), 100)
    }
  }

  async initializeAutocomplete() {
    try {
      await google.maps.importLibrary("places")

      const autocomplete = new google.maps.places.Autocomplete(this.inputTarget, {
        fields: ["name", "formatted_address", "address_components", "geometry", "place_id", "types"]
      })

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace()
        if (!place.geometry) return

        this.fillPlaceFields(place)
      })
    } catch (error) {
      console.error("Error initializing Places Autocomplete:", error)
    }
  }

  fillPlaceFields(place) {
    // Use formatted_address for regions (cities), name for establishments
    const isRegion = place.types?.some(type =>
      ["locality", "administrative_area_level_1", "administrative_area_level_2", "country"].includes(type)
    )

    const displayName = isRegion ? place.formatted_address : place.name

    this.nameTarget.value = displayName
    this.latitudeTarget.value = place.geometry.location.lat()
    this.longitudeTarget.value = place.geometry.location.lng()
    this.placeIdTarget.value = place.place_id

    // Fill address fields if present
    if (place.address_components) {
      this.fillAddressFields(place.address_components)
    }
  }

  fillAddressFields(components) {
    let streetNumber = ""
    let route = ""

    for (const component of components) {
      const type = component.types[0]
      const value = component.long_name

      switch(type) {
        case "street_number":
          streetNumber = value
          break
        case "route":
          route = value
          break
        case "locality":
          if (this.hasCityTarget) this.cityTarget.value = value
          break
        case "administrative_area_level_1":
          if (this.hasStateTarget) this.stateTarget.value = value
          break
        case "postal_code":
          if (this.hasPostalCodeTarget) this.postalCodeTarget.value = value
          break
        case "country":
          if (this.hasCountryTarget) this.countryTarget.value = value
          break
      }
    }

    if (this.hasStreetTarget) {
      this.streetTarget.value = `${streetNumber} ${route}`.trim()
    }
  }
}
